/* Theme product pages — buy box, bundle tiers, gifts, gallery, sticky bars.
   Needs vb.js (window.ThemeCart). Loaded once even if several sections include it. */
(function () {
  if (window.__vbProduct) return;
  window.__vbProduct = true;
  var d = document;
  var PRODUCTS = {};

  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function money(c) { return window.ThemeCart ? window.ThemeCart.money(c) : (c / 100).toFixed(2); }
  function pence(txt) { if (txt == null || String(txt).trim() === '') return null; var n = parseFloat(String(txt).replace(/[^\d.]/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
  function fill(tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }

  /* ---------- product data ---------- */
  function readProduct(section) {
    var s = section.querySelector('[data-vb-product-json]');
    if (!s) return null;
    try { var p = JSON.parse(s.textContent); PRODUCTS[p.id] = p; return p; } catch (e) { console.warn('Theme product JSON', e); return null; }
  }
  function productFor(box) {
    var id = box.getAttribute('data-product');
    if (PRODUCTS[id]) return PRODUCTS[id];
    var sec = d.querySelector('[data-vb-product="' + id + '"]');
    return sec ? readProduct(sec) : null;
  }
  function variant(p, id) { for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(id)) return p.variants[i]; return p.variants[0]; }

  // plan for a variant: the chosen plan if this variant has it, otherwise the variant's own first plan
  // (lets each pack-size variant carry its own subscription discount)
  function planFor(p, v) {
    if (!p.plan || !v.plans) return null;
    if (v.plans[p.plan] != null) return p.plan;
    for (var k in v.plans) if (Object.prototype.hasOwnProperty.call(v.plans, k)) return k;
    return null;
  }
  function tierCalc(p, t) {
    var v = variant(p, t.getAttribute('data-variant'));
    var qty = +t.getAttribute('data-qty') || 1;
    var plan = planFor(p, v);
    var unitSub = plan ? v.plans[plan] : v.price;
    var price = pence(t.getAttribute('data-price-override'));
    if (price == null) price = unitSub * qty;
    var onetime = pence(t.getAttribute('data-onetime-override'));
    if (onetime == null) onetime = v.price * qty;
    var cmpUnit = p.compareBasis === 'onetime' ? v.price : (v.compare > v.price ? v.compare : v.price);
    var compare = pence(t.getAttribute('data-compare-override'));
    if (compare == null) compare = cmpUnit * qty;
    if (compare <= price) compare = 0;
    return { v: v, qty: qty, price: price, compare: compare, saving: compare ? compare - price : 0, onetime: onetime, sub: !!plan, plan: plan };
  }

  /* ---------- buy box ---------- */
  function setText(root, sel, txt) { root.querySelectorAll(sel).forEach(function (n) { n.textContent = txt; n.hidden = !txt; }); }

  function selectTier(box, t, fromUser) {
    var p = productFor(box); if (!p || !t) return;
    if (fromUser && t.classList.contains('is-soldout')) return;
    var tiers = box.querySelectorAll('[data-vb-tier]');
    tiers.forEach(function (x) {
      var on = x === t;
      x.classList.toggle('is-active', on);
      x.setAttribute('aria-checked', on ? 'true' : 'false');
      x.setAttribute('tabindex', on ? '0' : '-1');
    });
    var c = tierCalc(p, t), idx = +t.getAttribute('data-vb-tier');
    box.__vbSel = { t: t, c: c, idx: idx };

    var scopes = [box];
    var sec = closest(box, '[data-vb-product]');
    if (sec && !box.hasAttribute('data-vb-clone')) { var satc = sec.querySelector('[data-vb-satc]'); if (satc) scopes.push(satc); }
    scopes.forEach(function (sc) {
      setText(sc, '[data-vb-p="price"]', money(c.price));
      setText(sc, '[data-vb-p="compare"]', c.compare ? money(c.compare) : '');
    });
    box.querySelectorAll('[data-vb-badge-tpl]').forEach(function (b) {
      b.textContent = fill(b.getAttribute('data-vb-badge-tpl'), { saving: money(c.saving) });
      b.hidden = !c.saving && /\{saving\}/.test(b.getAttribute('data-vb-badge-tpl'));
    });
    box.querySelectorAll('[data-vb-gifts] .vb-gift').forEach(function (g) {
      g.classList.toggle('is-locked', +g.getAttribute('data-unlock') > idx);
    });
    var ot = box.querySelector('[data-vb-onetime]');
    if (ot) ot.textContent = fill(ot.getAttribute('data-tpl'), { price: money(c.onetime), shipping: ot.getAttribute('data-ship') || '' });

    var media = +t.getAttribute('data-media');
    if (media > 0 && fromUser && sec) galleryGo(sec.querySelector('[data-vb-gallery]'), media - 1);
  }

  function initTiers(box) {
    var p = productFor(box); if (!p) return;
    box.querySelectorAll('[data-vb-tier]').forEach(function (t) {
      var c = tierCalc(p, t);
      setText(t, '[data-vb-t="price"]', money(c.price));
      setText(t, '[data-vb-t="compare"]', c.compare ? money(c.compare) : '');
      var tpl = t.getAttribute('data-save-tpl') || '';
      var txt = (!c.saving && /\{saving\}/.test(tpl)) ? '' : fill(tpl, { saving: money(c.saving), price: money(c.price), qty: c.qty });
      setText(t, '[data-vb-t="save"]', txt);
      var out = c.v && c.v.available === false;
      t.classList.toggle('is-soldout', out);
      t.setAttribute('aria-disabled', out ? 'true' : 'false');
      if (out && !t.querySelector('.vb-tier__out')) {
        var tag = d.createElement('span'); tag.className = 'vb-tier__out'; tag.textContent = box.getAttribute('data-soldout-label') || 'Sold out';
        var info = t.querySelector('.vb-tier__info'); if (info) info.appendChild(tag);
      }
    });
    var avail = function (t) { return t && !t.classList.contains('is-soldout'); };
    var def = box.querySelector('[data-vb-tier].is-active') || box.querySelector('[data-vb-tier="' + (box.getAttribute('data-default-tier') || 1) + '"]') || box.querySelector('[data-vb-tier]');
    if (def && !avail(def)) def = box.querySelector('[data-vb-tier]:not(.is-soldout)') || def;
    if (def) selectTier(box, def, false);
    else {
      // no tiers: price row + button show the default variant
      var v = p.variants[0], pl = planFor(p, v), price = pl ? v.plans[pl] : v.price;
      var cmp = p.compareBasis === 'onetime' ? v.price : v.compare;
      box.__vbSel = { c: { v: v, qty: 1, price: price, compare: cmp > price ? cmp : 0, saving: cmp > price ? cmp - price : 0, onetime: v.price, sub: !!pl, plan: pl }, idx: 1 };
      setText(box, '[data-vb-p="price"]', money(price));
      setText(box, '[data-vb-p="compare"]', cmp > price ? money(cmp) : '');
      var ot = box.querySelector('[data-vb-onetime]');
      if (ot) ot.textContent = fill(ot.getAttribute('data-tpl'), { price: money(v.price), shipping: ot.getAttribute('data-ship') || '' });
    }
  }

  function deliveryDate(el) {
    var days = +el.getAttribute('data-days') || 2, cutoff = +el.getAttribute('data-cutoff'), skip = el.getAttribute('data-weekends') === 'true';
    var dt = new Date();
    if (!isNaN(cutoff) && dt.getHours() >= cutoff) dt.setDate(dt.getDate() + 1);
    var added = 0;
    while (added < days) {
      dt.setDate(dt.getDate() + 1);
      if (!skip || (dt.getDay() !== 0 && dt.getDay() !== 6)) added++;
    }
    var out = el.querySelector('[data-vb-del-date]');
    if (out) out.textContent = dt.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function addToCart(box, oneTime) {
    var p = productFor(box), sel = box.__vbSel;
    if (!p || !sel || !window.ThemeCart) return;
    var btn = box.querySelector('[data-vb-atc]'), err = box.querySelector('[data-vb-err]');
    var c = sel.c;
    if (c.v && c.v.available === false) {
      if (err) { err.textContent = 'Sorry — this option is sold out. Please choose another.'; err.hidden = false; }
      return;
    }
    var main = { id: c.v.id, quantity: c.qty };
    if (c.plan && !oneTime) main.selling_plan = c.plan;
    var items = [main];
    if (!oneTime) {
      (p.gifts || []).forEach(function (g) {
        if (g.variant && g.available && g.unlock <= sel.idx) items.push({ id: g.variant, quantity: 1, properties: { _gift: 'true' } });
      });
    }
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    if (err) err.hidden = true;
    var done = function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } };
    var after = p.afterAdd || 'drawer', replace = !!p.replaceCart;
    window.ThemeCart.add(items, after, replace).catch(function (e) {
      if (items.length > 1) return window.ThemeCart.add([main], after, replace); // a gift may be out of stock — still add the main item
      throw e;
    }).catch(function (e) {
      if (err) { err.textContent = (e && (e.description || e.message)) || 'Sorry, something went wrong. Please try again.'; err.hidden = false; }
    }).then(done, done);
  }

  /* ---------- gallery ---------- */
  function galleryIndex(g) {
    var tr = g.querySelector('[data-vb-gal-track]');
    return tr && tr.clientWidth ? Math.round(tr.scrollLeft / tr.clientWidth) : 0;
  }
  function galleryGo(g, i) {
    if (!g) return;
    var tr = g.querySelector('[data-vb-gal-track]'); if (!tr) return;
    var n = tr.children.length; i = Math.max(0, Math.min(n - 1, i));
    tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' });
  }
  function galleryState(g) {
    var i = galleryIndex(g), th = g.querySelectorAll('[data-vb-gal-go]');
    th.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
    var a = th[i], wrap = g.querySelector('[data-vb-gal-thumbs]');
    if (a && wrap) {
      var l = a.offsetLeft - wrap.offsetLeft, r = l + a.offsetWidth;
      if (l < wrap.scrollLeft || r > wrap.scrollLeft + wrap.clientWidth) wrap.scrollTo({ left: l - wrap.clientWidth / 2 + a.offsetWidth / 2, behavior: 'smooth' });
    }
  }
  function initGallery(g) {
    var tr = g.querySelector('[data-vb-gal-track]');
    if (!tr || tr.__vb) return;
    tr.__vb = true;
    var to;
    tr.addEventListener('scroll', function () { clearTimeout(to); to = setTimeout(function () { galleryState(g); }, 60); }, { passive: true });
  }

  /* ---------- sticky left column + sticky ATC ---------- */
  function stickyLeft(sec) {
    var grid = sec.querySelector('.vb-pp__grid--sticky'), left = sec.querySelector('[data-vb-pp-left]');
    if (!grid || !left) return;
    var hdr = d.querySelector('.vb-header-section'), hh = hdr ? hdr.getBoundingClientRect().height : 70;
    var top = Math.min(hh + 16, window.innerHeight - left.offsetHeight - 16);
    left.style.top = top + 'px';
  }
  function initSatc(sec) {
    var bar = sec.querySelector('[data-vb-satc]'), atc = sec.querySelector('[data-vb-buybox]:not([data-vb-clone]) [data-vb-atc]');
    if (!bar || !atc || !('IntersectionObserver' in window) || atc.__vbio) return;
    atc.__vbio = true;
    new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var show = !x.isIntersecting && x.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = bar.querySelector('[data-vb-satc-btn]'); if (b) b.tabIndex = show ? 0 : -1;
      });
    }).observe(atc);
  }

  /* ---------- buy box clone (repeat section) ---------- */
  function initClones(scope) {
    scope.querySelectorAll('[data-vb-buybox-clone]').forEach(function (host) {
      var src = d.querySelector('[data-vb-product] [data-vb-buybox]:not([data-vb-clone])');
      if (!src) { host.innerHTML = '<p class="vb-clone-empty">Add the “Theme · Main product” section to this template to show the buy box here.</p>'; return; }
      var cl = src.cloneNode(true);
      cl.setAttribute('data-vb-clone', '');
      cl.removeAttribute('id');
      (host.getAttribute('data-remove') || '').split(',').forEach(function (sel) {
        sel = sel.trim(); if (sel) cl.querySelectorAll(sel).forEach(function (n) { n.remove(); });
      });
      cl.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) { n.removeAttribute('data-shopify-editor-block'); });
      cl.querySelectorAll('[data-vb-tier]').forEach(function (t) { t.classList.remove('is-active'); });
      host.innerHTML = '';
      host.appendChild(cl);
      initBox(cl);
    });
  }

  /* ---------- carousel dots (generic) ---------- */
  function initDots(c) {
    var dots = c.querySelector('[data-vb-dots]'), tr = c.querySelector('[data-vb-track]');
    if (!dots || !tr || dots.__vb) return;
    dots.__vb = true;
    var render = function () {
      var n = tr.children.length, per = Math.max(1, Math.round(tr.clientWidth / ((tr.firstElementChild || tr).getBoundingClientRect().width || 1)));
      var pages = Math.max(1, n - per + 1);
      if (dots.children.length !== pages) {
        dots.innerHTML = '';
        for (var i = 0; i < pages; i++) { var b = d.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1)); b.setAttribute('data-i', i); dots.appendChild(b); }
      }
      var w = (tr.firstElementChild || tr).getBoundingClientRect().width + (parseFloat(getComputedStyle(tr).columnGap) || 0);
      var cur = Math.round(tr.scrollLeft / (w || 1));
      [].forEach.call(dots.children, function (b, k) { b.classList.toggle('is-active', k === Math.min(cur, pages - 1)); });
      dots.hidden = pages < 2;
    };
    tr.addEventListener('scroll', function () { render(); }, { passive: true });
    window.addEventListener('resize', render);
    dots.addEventListener('click', function (e) {
      var b = closest(e.target, 'button[data-i]'); if (!b) return;
      var w = (tr.firstElementChild || tr).getBoundingClientRect().width + (parseFloat(getComputedStyle(tr).columnGap) || 0);
      tr.scrollTo({ left: +b.getAttribute('data-i') * w, behavior: 'smooth' });
    });
    render();
  }

  /* ---------- init ---------- */
  function initBox(box) {
    initTiers(box);
    box.querySelectorAll('[data-vb-delivery]').forEach(deliveryDate);
    requestAnimationFrame(function () { box.querySelectorAll('[data-vb-sold-fill]').forEach(function (f) { f.classList.add('is-in'); }); });
  }
  function init(scope) {
    scope = scope || d;
    scope.querySelectorAll('[data-vb-product]').forEach(function (sec) {
      readProduct(sec);
      sec.querySelectorAll('[data-vb-buybox]:not([data-vb-clone])').forEach(initBox);
      sec.querySelectorAll('[data-vb-gallery]').forEach(initGallery);
      stickyLeft(sec);
      initSatc(sec);
    });
    initClones(scope === d ? d : scope);
    scope.querySelectorAll('[data-vb-carousel]').forEach(initDots);
  }

  d.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = closest(t, '[data-vb-tier]'))) { selectTier(closest(el, '[data-vb-buybox]'), el, true); return; }
    if ((el = closest(t, '[data-vb-atc]'))) { addToCart(closest(el, '[data-vb-buybox]'), false); return; }
    if ((el = closest(t, '[data-vb-onetime]'))) { addToCart(closest(el, '[data-vb-buybox]'), true); return; }
    if ((el = closest(t, '[data-vb-satc-btn]'))) {
      var box = closest(el, '[data-vb-product]').querySelector('[data-vb-buybox]:not([data-vb-clone])');
      addToCart(box, false); return;
    }
    if ((el = closest(t, '[data-vb-gal-go]'))) { galleryGo(closest(el, '[data-vb-gallery]'), +el.getAttribute('data-vb-gal-go')); return; }
    if ((el = closest(t, '[data-vb-gal-prev]'))) { var g = closest(el, '[data-vb-gallery]'); galleryGo(g, galleryIndex(g) - 1); return; }
    if ((el = closest(t, '[data-vb-gal-next]'))) { var g2 = closest(el, '[data-vb-gallery]'); galleryGo(g2, galleryIndex(g2) + 1); return; }
    if ((el = closest(t, '[data-vb-toggle]'))) {
      var card = closest(el, '[data-vb-toggleable]'), open = !card.classList.contains('is-open');
      if (card.parentElement.hasAttribute('data-single')) card.parentElement.querySelectorAll('[data-vb-toggleable].is-open').forEach(function (o) { if (o !== card) { o.classList.remove('is-open'); var ob = o.querySelector('[data-vb-toggle]'); if (ob) ob.setAttribute('aria-expanded', 'false'); } });
      card.classList.toggle('is-open', open); el.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });
  d.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t.hasAttribute || !t.hasAttribute('data-vb-tier')) return;
    var box = closest(t, '[data-vb-buybox]'), all = [].slice.call(box.querySelectorAll('[data-vb-tier]')), i = all.indexOf(t);
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectTier(box, t, true); }
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); var n = all[(i + 1) % all.length]; selectTier(box, n, true); n.focus(); }
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); var pv = all[(i - 1 + all.length) % all.length]; selectTier(box, pv, true); pv.focus(); }
  });
  window.addEventListener('resize', function () { d.querySelectorAll('[data-vb-product]').forEach(function (s) { stickyLeft(s); s.querySelectorAll('[data-vb-gallery]').forEach(galleryState); }); });
  window.addEventListener('load', function () { d.querySelectorAll('[data-vb-product]').forEach(stickyLeft); });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();

  d.addEventListener('shopify:section:load', function (e) { init(e.target); if (e.target.querySelector('[data-vb-product]')) initClones(d); });
  d.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (t.hasAttribute && t.hasAttribute('data-vb-tier')) selectTier(closest(t, '[data-vb-buybox]'), t, true);
    if (t.matches && t.matches('details')) t.open = true;
  });
})();
